export default "__VITE_ASSET__BGIqLK1X__"